<template>
    <div v-if="question">
        <additional-component v-if="showedInfo" :id="question.key"></additional-component>

        <template v-else>
            <info-block @success="showedInfo = true; $root.$emit('aside', true)" :title="infoData.title" :content="infoData.content"></info-block>
        </template>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import AdditionalComponent from './questions/index'
    import InfoBlock from './info'
    import InfoData from './data'

    export default {
        components: {
            AdditionalComponent,
            InfoBlock
        },
        data () {
            return {
                showedInfo: false
            }
        },
        computed: {
            ...mapGetters('questions', ['question']),
            ...mapGetters('progress', ['block']),
            infoData () {
                return InfoData
            }
        },
        mounted () {
            this.$root.$emit('aside', false)
            this.init()
        },
        methods: {
            init () {
                this.$store.dispatch('questions/init', {stage: 'solving'})
            }
        }
    }
</script>
